import { Component, OnInit } from '@angular/core';
import { User } from '../../@core/data/users'
import { UserService } from '../../@core/api/users.service'
import { AngularFireStorage } from '@angular/fire/storage';
import { MessageHandlerService } from '../../services/message-handler.service'
import { LenguageService } from '../../@core/utils/lenguage.service'

@Component({
  selector: 'ngx-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {

  loading: boolean = false;
  uploading: boolean = false;
  embed: boolean = false;
  showPassword: boolean = false;
  admin: boolean;
  user: User;
  id: string
  uploadProgress: any;
  uploadProgressMenu: any = [];
  files: any;
  constructor(
    private userService: UserService, 
    private afStorage: AngularFireStorage,
     private messageHandler: MessageHandlerService,
     public language: LenguageService) {

  }

  async ngOnInit() {
    this.init()
    this.userService.subscribeToUpdate().subscribe( data => {
      this.init()
    })
  }

  upload(event) {
    const randomId = Math.random().toString(36).substring(2);
    let ref = this.afStorage.ref("/profilePics/"+randomId);
    let task = ref.put(event.target.files[0]);
    this.uploading = true;
    this.uploadProgress = task.percentageChanges();
    task.then(async (a) => {
      let downloadUrl = await ref.getDownloadURL().toPromise();
      this.uploading = false;
      this.user.profilePic = downloadUrl;
      await this.save();
    });
  }

  async init() {
    let logged = await this.userService.getLoggedUser()
    this.admin = (logged.userType === "admin") ? true : false;
    if (!this.user) {
      this.loading = true;
      this.user = <User>await this.userService.getCurrentUser();
      this.loading = false;
    }
  }

  async save() {

    this.loading = true;
    try {
      await this.userService.editUser(this.user, this.id)
      this.messageHandler.success();
      await this.userService.updateLoggedUser();
      this.userService.updateListeners();
    } finally {
      this.loading = false;
    }
  }
  
  
  getInputType() {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

}
